import React from "react"
import PropTypes from "prop-types"

import GenericPage from "components/GenericPage"
import { API_URL } from "api/api"

import history from "appHistory"
import decodeURL from "./urlHelpers/decodeURL"

// uriKeys & uriPattern generated using npm package "path-to-regexp": "^2.2.1"
const uriKeys = [{
  "name": "type",
  // "prefix": "/",
  // "delimiter": "/",
  // "optional": false,
  // "repeat": false,
  // "partial": false,
  // "pattern": "[r|b|raw|base64]"
}, {
  "name": "uri",
  // "prefix": "/",
  // "delimiter": "/",
  // "optional": false,
  // "repeat": false,
  // "partial": false,
  // "pattern": ".*"
}]
// const uriPattern = toRegex("/:type([r|b|raw|base64])/:uri(.*)", uriKeys)
const uriPattern = /^\/([r|b|raw|base64])\/(.*)(?:\/)?$/i

function matchURI(path) {
  const match = uriPattern.exec(path)
  if (!match) {
    return null
  }
  const params = {}
  for (let i = 1, len = match.length; i < len; ++i) {
    params[uriKeys[i - 1].name] = match[i] !== undefined ? match[i] : undefined
  }
  return params
}


class App extends React.PureComponent {
  static propTypes = {
    location: PropTypes.object,
  }

  static defaultProps = {
    location: document.location,
  }

  state = {
    location: this.props.location,
  }

  componentDidMount() {
    this.unlisten = history.listen(this.onHistoryChange)
  }

  componentWillUnmount() {
    this.unlisten && this.unlisten()
  }

  onHistoryChange = (location) => {
    this.setState(() => ({ location }))
  }

  render() {
    const { pathname, search } = this.state.location
    let uri
    const params = matchURI(pathname)
    if (params) {
      const { type } = params
      uri = params.uri
      if (type === "b" || type === "base64") {
        try {
          uri = decodeURL(this.state.location.pathname)
        } catch (error) {
          // Render error page here
          console.error(error)
          return <GenericPage id={uri} history={history}/>
        }
      }
    } else {
      uri = `${API_URL}${pathname}`
    }
    uri = `${uri}${search}`
    return <GenericPage id={uri} history={history}/>
  }
}
export default App
